// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-button[data-v-45878f78]{color:#000;font-weight:700;margin:0 2px}.custom-button[data-v-45878f78]:hover{background:#9d57f4;color:#fff;font-weight:700}", ""]);
// Exports
module.exports = exports;
